import { UseMutationOptions } from '@tanstack/react-query';

import useMutation from 'hooks/useMutation';

import MutationKeys from './keys';

import type { MessageFeedbackBody } from 'domains/content/components/CopyGeneratorChat/utils';

export type { MessageFeedbackBody };

/**
 * Submits or updates feedback (like/dislike) for a single assistant message.
 * Upserts on (message_id, user_id) — calling again overwrites prior feedback.
 * @see POST /copy-generator/messages/:messageId/feedback
 */
const useSubmitMessageFeedback = (
    messageId: number,
    mutateOptions?: UseMutationOptions<void, Error, MessageFeedbackBody>
) =>
    useMutation<MessageFeedbackBody, void, Error>(
        MutationKeys.COPY_GENERATOR_MESSAGE_FEEDBACK(messageId),
        `copy-generator/messages/${messageId}/feedback`,
        mutateOptions
    );

export default useSubmitMessageFeedback;
